import type { CSSProperties } from 'react';

import classNames from 'classnames';

import SimpleModal from '@/ui/SimpleModal';

import { ButtonElement } from '../shared/buttonElement/ButtonElement.js';
import { actionModalContent } from './ActionModalElement.css';
import type { ActionModalElementProps } from './ActionModalElement.types.js';

export function ActionModalElement({
  isOpen,
  onOpenChange,
  isLoading,
  children,
  title,
  message,
  submitLabel,
  onClick,
}: ActionModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={(open: boolean) => {
        if (!isLoading) {
          onOpenChange?.(open);
        }
      }}
      className="shadow-lg overflow-hidden sm:rounded-md"
      style={generatedStyle}
      showRoundedBorders={false}
      shouldCloseOnOutsideClick={!isLoading}
    >
      <div className={classNames(actionModalContent, 'w-full flex flex-col gap-6')}>
        <div className="flex flex-col gap-1 w-full">
          <h1 className="text-gray-900 text-lg font-bold leading-7 w-full text-center">{title}</h1>
          <p className="text-gray-500 text-sm font-normal leading-5 w-full text-center">{message}</p>
        </div>
        {children}
        <ButtonElement
          onClick={onClick}
          type={onClick ? 'button' : 'submit'}
          variant="flush"
          className="underline"
          disabled={isLoading}
        >
          {submitLabel}
        </ButtonElement>
      </div>
    </SimpleModal>
  );
}
